import { useLayoutEffect } from 'react';
import { useIsFocusedTab, useLogAnalyticsEvent } from 'shared/src/hooks';

export const useLogViewOverview = () => {
  const isFocusedTab = useIsFocusedTab();
  const logAnalyticsEvent = useLogAnalyticsEvent();

  // useEffect 대신 useLayoutEffect 로 발화해서 자식(RetailAdBanner) 의
  // useEffect 기반 CALL_ADS 보다 먼저 VIEW_OVERVIEW 가 emit 되도록 보장.
  // React effect 순서: 자식 useLayoutEffect → 부모 useLayoutEffect →
  //   자식 useEffect → 부모 useEffect. 부모의 useLayoutEffect 는 자식
  //   useEffect 보다 먼저 실행되므로 native iOS 의 발화 순서와 일치한다.
  useLayoutEffect(() => {
    if (isFocusedTab) {
      logAnalyticsEvent({
        name: 'VIEW_OVERVIEW',
      });
    }
  }, [isFocusedTab, logAnalyticsEvent]);
};
